<script>
	import { convert } from "src/services/helpers";

	export let row = {};
	export let key = "";
	export let className = "";
	export let format = "";
	export let sortCol;
	export let index = -1;
	export let event;
	export let action;
	export let options = [];
	export let label = "";
</script>

<span class={className}>
	{convert(row[key], format) || "-"}
</span>

<style>
	.table-datetime {
		color: var(--fds-on-surface-variant);
		font-weight: bold;
		width: fit-content;
	}
</style>
